import storage from './storage';
import request from './request';

//
export default {
    ...request,
    ...storage,
};
